import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FocusClickDirective } from "./focus-click/focus-click.directive";
import { NgLetDirective } from "./ng-let/ng-let.directive";

@NgModule({
	imports: [CommonModule, FocusClickDirective],
	declarations: [NgLetDirective],
	exports: [FocusClickDirective, NgLetDirective],
})
export class UIDirectivesModule {}
